// extracted by mini-css-extract-plugin
export default {"wrapper":"vi4jOfduaKA9xvqoLdma","big":"eUrP01Pm_2xLcrsYUaej","badge":"ZQSpy5Mq2rlHdFWpPoie","deletion":"jtmoSSFUEb7pyaedpNgy"};